import React, { useState, useEffect, useRef } from 'react';
import type { Element } from 'react';
import { Tooltip } from '@material-ui/core';

// Ellipsis component will trim long strings if text overflows the parent element width.
// Usage: put <Ellipsis /> component inside of the parent with limited width (width or min-width can be set on parent component
// or on any of the predecessors or explicitly pass the width.

type Props = {
  children: Element,
  showTooltip?: boolean,
  width?: string | number,
};

const Ellipsis = ({ children, showTooltip = true, width = 'auto' }: Props) => {
  const [shouldShowTooltip, toggleShowTooltip] = useState(false);
  const textEl = useRef(null);

  useEffect(() => {
    if (
      textEl &&
      textEl.current &&
      textEl.current.clientWidth < textEl.current.scrollWidth
    ) {
      toggleShowTooltip(true);
    }
  }, [children]);

  if (showTooltip && shouldShowTooltip) {
    return (
      <Tooltip title={children}>
        <div
          ref={textEl}
          style={{
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            width,
            maxWidth: '17rem',
          }}
        >
          {children}
        </div>
      </Tooltip>
    );
  }

  return (
    <div
      ref={textEl}
      style={{
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        width,
      }}
    >
      {children}
    </div>
  );
};

export default Ellipsis;
